import React, { ReactNode } from 'react'
import './content-card.css'
import { Badge } from '@paypalcorp/pp-react'

interface ContentCardProps {
  badgeType?:
    | 'feature'
    | 'success'
    | 'warning'
    | 'critical'
    | 'neutral'
    | undefined
  badgeText?: string
  icon?: ReactNode
  onClick?: () => void
  content: ReactNode | ReactNode[]
}

export const ContentCard: React.FC<ContentCardProps> = ({
  badgeType = 'feature',
  badgeText = '',
  icon,
  onClick,
  content,
}) => {
  return (
    <div className="content-card--container">
      <div className="content-card--wrapper-top">
        {icon}
        <Badge type="feature">{badgeText}</Badge>
      </div>
      <div>{content}</div>
    </div>
  )
}
